export const baseFont = '"Montserrat", "Helvetica Neue", Helvetica, Arial, MyYuGothicM, YuGothic, sans-serif';
export const numericFont = 'Verdana, sans-serif';



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/sharedStyle/font.ts